var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("EditModal", {
        ref: "editmodal",
        attrs: {
          availableSalutations: [],
          allUsers: _vm.allUsers,
          groupSelector: _vm.groupSelector,
          groupCopyFunction: _vm.groupCopyFunction,
          groupSaveFunction: _vm.groupSaveFunction,
          hiddenTabs: ["usersExternal"],
          hidePinned: true
        },
        scopedSlots: _vm._u(
          [
            {
              key: "editModalTitle",
              fn: function() {
                return [
                  _vm._t("editModalTitle", function() {
                    return [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$t("maintenance.cell.access.editModal.title")
                          ) +
                          "\n      "
                      )
                    ]
                  })
                ]
              },
              proxy: true
            },
            {
              key: "editModalTabs",
              fn: function({ group }) {
                return [_vm._t("editModalTabs", null, { group: group })]
              }
            },
            {
              key: "generalAfter",
              fn: function({ group }) {
                return [
                  _vm._t(
                    "generalAfter",
                    function() {
                      return [
                        _c("label", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "maintenance.cell.access.groupModal.chooseCells.title"
                              )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("GroupCellEditor", { attrs: { group: group } })
                      ]
                    },
                    { group: group }
                  )
                ]
              }
            },
            {
              key: "userButtonsBefore",
              fn: function({ groupUser }) {
                return [
                  _vm._t("userButtonsBefore", null, { groupUser: groupUser }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-secondary",
                      on: {
                        click: function($event) {
                          return _vm.openMailUserModal(groupUser)
                        }
                      }
                    },
                    [_c("i", { staticClass: "fa fa-at" })]
                  )
                ]
              }
            },
            {
              key: "userButtonsAfter",
              fn: function({ groupUser }) {
                return [
                  _vm._t("userButtonsAfter", null, { groupUser: groupUser })
                ]
              }
            },
            {
              key: "externalUserButtonsBefore",
              fn: function({ groupUserExternal }) {
                return [
                  _vm._t("externalUserButtonsBefore", null, {
                    groupUserExternal: groupUserExternal
                  })
                ]
              }
            },
            {
              key: "externalUserButtonsAfter",
              fn: function({ groupUserExternal }) {
                return [
                  _vm._t("externalUserButtonsAfter", null, {
                    groupUserExternal: groupUserExternal
                  })
                ]
              }
            },
            {
              key: "selectedExternalUserButtonsBefore",
              fn: function({ groupUserExternals }) {
                return [
                  _vm._t("selectedExternalUserButtonsBefore", null, {
                    groupUserExternals: groupUserExternals
                  })
                ]
              }
            },
            {
              key: "selectedExternalUserButtonsAfter",
              fn: function({ groupUserExternals }) {
                return [
                  _vm._t("selectedExternalUserButtonsAfter", null, {
                    groupUserExternals: groupUserExternals
                  })
                ]
              }
            },
            {
              key: "externalUserSelectModalTabs",
              fn: function() {
                return [_vm._t("externalUserSelectModalTabs")]
              },
              proxy: true
            }
          ],
          null,
          true
        )
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }